import { ColumnFiltersState } from "@tanstack/react-table";
import { ApiVersion } from "../const";
import { Machine } from "../models/Machine";

export const getAllMachines = (token: string) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAllMachines`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}
export const getMachinesPage = (
    token: string,
    page: number,
    limit: number,
    filters: ColumnFiltersState,
    sortBy: string,
    sortDir: string,
    globalSearch?: string
) => {
    const filt = JSON.stringify(filters);
    const url =
        `${process.env.REACT_APP_API_URL}${ApiVersion}getMachinesPage` +
        `?page=${page}&limit=${limit}&filters=${encodeURIComponent(filt)}` +
        `&sortBy=${sortBy}&sortDir=${sortDir}` +
        (globalSearch ? `&globalSearch=${encodeURIComponent(globalSearch)}` : '');

    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    }).then(r => (r.ok ? r.json() : Promise.reject(r)));
};

export const getMachinesByCompany = (token: string, idcompany: number) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getMachinesByCompany/${idcompany}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const getMachinesByInstallation = (token: string, idinstallation: number) =>{
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getMachinesByInstallation/${idinstallation}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const getMachineImages = (token: string, idmachine: number) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getMachineImages/${idmachine}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const getAllMachineStates = (token: string, idmachine: number, iniD: string, endD: string) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ iniDate: iniD, finDate: endD })
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAllMachineStates/${idmachine}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const newMachine = (token: string, machine: Machine) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(machine)
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}createMachine/${machine.idmachine}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const deleteMachine = (token: string, idmachine: number) => {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}deleteMachine/${idmachine}`, requestOptions)
}

export const resetMachineData = (token: string, idmachine: number) => {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}resetMachineData/${idmachine}`, requestOptions)
}

export const setMachineStateSolved = (token: string, id: number, solved: boolean) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ idmachineState: id, solved: solved })
    };
    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}setMachineStateSolved`, requestOptions)
        .then(response => {
            if (!response.ok) throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })

}

export const getGeneralData = (token: string, id: number, type: number) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ id: id, type: type })
    };
    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getGeneralData`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })

}


export const updateMachineParams = (token: string, idmachine: number, hum: number, tem: number, state: boolean) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ humiditySetPoint: hum, temperatureSetPoint: tem, machineState: state })
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}updateMachineParams/${idmachine}`, requestOptions)
}